import type { ToolAccessName } from '@/types';

/**
 * Validate input and checks if user has required permission
 */
export function checkUserToolAccess(userGroups: readonly string[], requiredPermission: ToolAccessName): boolean {
    // Validate input parameters
    if (!Array.isArray(userGroups) || !requiredPermission) {
        return false;
    }

    // Validate all group items are strings
    if (!userGroups.every(g => typeof g === 'string')) {
        return false;
    }

    // Admin has access to everything
    if (userGroups.some(g => g.endsWith('.Admin'))) {
        return true;
    }

    // Check specific permission
    const hasPermission = userGroups.some(g => g.endsWith(`.${requiredPermission}`));
    return hasPermission;
}
